import React, { useState } from 'react';
const Code = (props) => {
    const [code, setCode] = useState('');
    const handleCodeChange = (e) => {
        setCode(e.target.value);
    };
    return (React.createElement("div", { className: "code-form-container" },
        React.createElement("div", { className: "code-form" },
            React.createElement("input", { type: "text", className: "code-form__code", placeholder: "Enter Code", defaultValue: code, onChange: () => handleCodeChange }),
            React.createElement("button", { className: "btn--primary code-form__submit", onClick: () => props.onSubmit(code) }, "SUBMIT")),
        React.createElement("p", { style: { color: 'red' } }, props.message)));
};
export { Code };
